export default __webpack_public_path__ + "76fc502bbecc705472d18418ea35696d.png";